import { default as apiInit } from "@pcloud/web-utilities/dist/api/init";

export default apiInit;
